import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SentimentDissatisfied from '@mui/icons-material/SentimentDissatisfied';

export default function NotFoundPage() {
  return (
    <Stack sx={{ width: '100%' }} justifyContent="center" alignItems="center">
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{ mt: 6, mb: 1 }}
        gap={1}
      >
        <SentimentDissatisfied />
        <Typography variant="h4">Page Not Found</Typography>
      </Stack>

      <Typography variant="body1">
        Sorry, the page you are looking for does not exist.
      </Typography>
    </Stack>
  );
}
